import { useQuery } from '@tanstack/react-query';

import {
  campaignsService,
  ForecastedCycle,
  ForecastScheduleRequest,
} from '@aslanpay/portal-common-lib';

/**
 * The cycles a schedule and a rule would produce.
 * <p>
 * A read expressed as a POST, because the question carries a whole schedule and a rule. Keyed on the request,
 * so changing the repeat re-asks it and changing nothing does not.
 */
const useForecastSchedule = (request: ForecastScheduleRequest | undefined) => {
  return useQuery<ForecastedCycle[], Error>(
    ['forecastSchedule', request],
    () => campaignsService.forecastSchedule(request as ForecastScheduleRequest),
    { enabled: !!request, retry: false, keepPreviousData: true }
  );
};

export default useForecastSchedule;
